import React from "react";
import _ from "lodash";
import styled from "styled-components";
import { connect } from "formik";
import num from "numeral";
import { Grid, Checkbox } from "@material-ui/core";

import { TextInput, PercentInput } from "../../../Global/FastFormikMaterial";

import ViewOnlyDiv from "./ViewOnlyDiv";

const Label = styled.div`
  font-size:17px !important;
  font-weight:bold;
  color: rgb(51,51,51)
  min-width:200px;
`;

const LabelGrid = styled(Grid)`
  && {
    width: 200px;
  }
`;

const FormGrid = styled(Grid)`
  min-height: 40px;
  border-bottom: ${props => (props.hasBorder ? "1px solid gainsboro" : "")};
`;

class SideLabelHideablePercentWithRefInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isEditVisible: Boolean(_.get(props.formik.values, props.fieldName)) };
  }

  render() {
    const { label, fieldName, placeholder, formik, isDisabled, hasBorder, decimalScale, shouldHideForQuote, shouldHideRef, ...otherProps } = this.props;

    if (shouldHideForQuote) {
      return null;
    }

    const val = _.get(formik.values, fieldName);
    const refVal = _.get(formik.values, `${fieldName}Ref`);

    return (
      <Grid container direction="row" alignItems="center" style={{ height: 40, paddingLeft: isDisabled ? 0 : 25 }}>
        {!isDisabled && (
          <Checkbox
            checked={this.state.isEditVisible}
            onClick={() => {
              this.setState(prevState => ({ isEditVisible: !prevState.isEditVisible }));
            }}
          />
        )}
        <LabelGrid container item alignItems="flex-start">
          <Label>{label}</Label>
        </LabelGrid>

        {this.state.isEditVisible && (
          <FormGrid hasBorder={hasBorder} container item alignItems="center" style={{ marginLeft: isDisabled ? 30 : -5, width: 646 }}>
            {isDisabled && (
              <Grid container item spacing={16}>
                <Grid item style={{ width: shouldHideRef ? 661 : 542 }}>
                  <ViewOnlyDiv>{val ? num(val / 100.0).format(`0.${"0".repeat(decimalScale)}%`) : ""}</ViewOnlyDiv>
                </Grid>
                {!shouldHideRef &&
                  <Grid item style={{ width: 119 }}>
                    <ViewOnlyDiv placeholder="No reference">{refVal}</ViewOnlyDiv>
                  </Grid>}
              </Grid>
            )}
            {!isDisabled && (
              <Grid container item spacing={16}>
                <Grid item style={{ width: shouldHideRef ? 661 : 481 }}>
                  <PercentInput fullWidth fieldName={fieldName} placeholder={placeholder} {...otherProps} />
                </Grid>
                {!shouldHideRef &&
                  <Grid item style={{ width: 180 }}>
                    <TextInput fullWidth fieldName={`${fieldName}Ref`} placeholder="Add a reference" {...otherProps} />
                  </Grid>}
              </Grid>
            )}
          </FormGrid>
        )}
      </Grid>
    );
  }
}

export default connect(SideLabelHideablePercentWithRefInput);
